import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M0 25c0 9.476 5.272 17.72 13.043 21.96V3.04C5.274 7.28 0 15.524 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M24.999 0a24.889 24.889 0 0 0-11.957 3.04v43.92A24.889 24.889 0 0 0 25 50c13.807 0 25-11.193 25-25s-11.193-25-25-25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M35.688 29.137a7.065 7.065 0 1 1-5.054-12.733 8.696 8.696 0 1 0 7.281 10.077 7.033 7.033 0 0 1-2.227 2.656ZM35.552 16.305l1.781 1.92 2.377-1.101-1.276 2.287 1.782 1.92-2.57-.506-1.276 2.288-.312-2.6-2.57-.507 2.377-1.1-.313-2.601Z"
}));
FlagPK.displayName = 'FlagPK';
export default withFlagWrapper(FlagPK);
//# sourceMappingURL=index.js.map